module.exports = __webpack_public_path__ + "img/limited-time-item-bg.81997fe1.png";